import e from "./underscore.js";
import r from "./_baseIteratee.js";
import t from "./iteratee.js";
function o(o, a, i) {
  return e.iteratee !== t ? e.iteratee(o, a) : r(o, a, i);
}
export { o as default };